module.exports = __webpack_public_path__ + "img/05_img.9cc8e54c.png";